import { createSlotRecipe } from './runtime.js';

const radioBoxConfig = {"name":"radioBox","slots":["root","checkIcon","thumbnail","textGroup","title","desc"],"defaultVariants":{"size":"md"},"variantMap":{"size":["md","sm"]}}

export const radioBox = /* @__PURE__ */ createSlotRecipe(radioBoxConfig)